<div class="runner-radio-list__title" [id]="headingId">{{ 'testCases.runDialog.runners.title' | translate }}</div>
<p class="runner-radio-list__intro">{{ 'testCases.runDialog.runners.intro' | translate }}</p>

@switch (loadState()) {
  @case ('loading') {
    <p class="runner-radio-list__state" data-testid="run-runners-loading">
      <mat-progress-spinner mode="indeterminate" diameter="16" aria-hidden="true" />
      {{ 'testCases.runDialog.runners.loading' | translate }}
    </p>
  }
  @case ('failed') {
    <div class="runner-radio-list__state runner-radio-list__state--error" role="alert">
      <mat-icon aria-hidden="true">error</mat-icon>
      <span>{{ 'testCases.runDialog.runners.loadFailed' | translate }}</span>
      <button
        mat-stroked-button
        type="button"
        class="runner-radio-list__retry"
        data-testid="run-runners-retry"
        (click)="reload()"
      >
        {{ 'testCases.runDialog.runners.retry' | translate }}
      </button>
    </div>
  }
  @default {
    @if (runners().length === 0) {
      <p class="runner-radio-list__state" data-testid="run-runners-none">
        <mat-icon aria-hidden="true">info</mat-icon>
        {{ 'testCases.runDialog.runners.none' | translate }}
      </p>
    } @else {
      @if (allOffline()) {
        <p class="runner-radio-list__state" data-testid="run-runners-all-offline">
          <mat-icon aria-hidden="true">info</mat-icon>
          {{ 'testCases.runDialog.runners.allOffline' | translate }}
        </p>
      }
      <div class="runner-radio-list__group" role="radiogroup" [attr.aria-labelledby]="headingId">
        @for (runner of runners(); track runner.id) {
          <div
            class="runner-radio"
            role="radio"
            [class.runner-radio--checked]="isSelected(runner.id)"
            [class.runner-radio--offline]="!runner.online"
            [attr.data-testid]="'run-runner-option-' + runner.id"
            [attr.data-online]="runner.online"
            [attr.data-value]="runner.id"
            [attr.aria-checked]="isSelected(runner.id)"
            [attr.aria-disabled]="runner.online ? null : true"
            [attr.tabindex]="tabStop() === runner.id ? 0 : -1"
            (click)="choose(runner.id)"
            (keydown)="onKeydown($event, runner.id)"
          >
            <span class="runner-radio__dot" aria-hidden="true"></span>
            <span class="runner-radio__icon" aria-hidden="true"><mat-icon aria-hidden="true">settings</mat-icon></span>
            <span class="runner-radio__body">
              <span class="runner-radio__head">
                <span class="runner-radio__name">{{ runner.name }}</span>
                <span class="runner-radio__badge" [class.runner-radio__badge--online]="runner.online">
                  {{
                    (runner.online ? 'testCases.runDialog.runners.online' : 'testCases.runDialog.runners.offline')
                      | translate
                  }}
                </span>
              </span>
              <span class="runner-radio__meta">
                {{ runner.version ? runner.engine + ' · ' + runner.version : runner.engine }}
              </span>
            </span>
          </div>
        }
        @if (labels().length > 0) {
          <div class="runner-radio-list__subtitle" data-testid="run-runner-label-group">
            {{ 'testCases.runDialog.runners.groupRequirement' | translate }}
          </div>
          @for (label of labels(); track label) {
            <div
              class="runner-radio"
              role="radio"
              [class.runner-radio--checked]="isSelected(labelPrefix + label)"
              [attr.data-testid]="'run-runner-label-option-' + label"
              [attr.data-value]="labelPrefix + label"
              [attr.aria-checked]="isSelected(labelPrefix + label)"
              [attr.tabindex]="tabStop() === labelPrefix + label ? 0 : -1"
              (click)="choose(labelPrefix + label)"
              (keydown)="onKeydown($event, labelPrefix + label)"
            >
              <span class="runner-radio__dot" aria-hidden="true"></span>
              <span class="runner-radio__name">
                {{ 'testCases.runDialog.runners.anyWithLabel' | translate: { label } }}
              </span>
            </div>
          }
        }
      </div>
    }
  }
}
